const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/

export const validateMisPulse = (pulse) => {
  const errors = {}
  const emails = String(pulse.emails || '').split(',').map((email) => email.trim()).filter(Boolean)

  if (!pulse.frequency) errors.frequency = 'Frequency is required'
  if (!pulse.pulse_type) errors.pulse_type = 'Pulse type is required'
  if (!pulse.sids?.length) errors.sids = 'Select at least one company'
  if (!emails.length) errors.emails = 'Enter at least one email address'
  else if (emails.some((email) => !EMAIL_PATTERN.test(email))) errors.emails = 'Enter valid comma-separated email addresses'
  if (pulse.frequency === 'weekly' && !pulse.day_of_week) errors.day_of_week = 'Day of week is required'
  if (pulse.frequency === 'monthly' && !pulse.day_of_month) errors.day_of_month = 'Day of month is required'

  return errors
}
